// use as default return value in switch to force tsc exhaustive case checking
export default function assertUnreachable(value: never): never {
  throw new Error(`Unhandled case: ${value}`);
}
